import ChatBotContextProvider from "./context/ChatBotContextProvider";
import { MainChat } from "./components/MainChat";
import "../../styles/chat/chat-window.scss";

export const ChatBot = () => {

    return (
        <ChatBotContextProvider>
            <MainChat />
        </ChatBotContextProvider>
    );
}


